import React from 'react';
import {
    AndetToolbarTitle,
    AndetToolbarWrapper,
    ToggleIcon,
    ToolbarContent,
    ToolbarSportIcon,
} from './styled';
import { APP_PATH } from '../../constants/appConfig';

const ViewAnderSportToolbar = ({ toggleHandler, sportId, title }) => {
    return (
        <AndetToolbarWrapper
            id={title
                .toLowerCase()
                .split(' ')
                .join('-')}
            onClick={toggleHandler}
        >
            <ToolbarContent>
                <ToolbarSportIcon
                    src={`${APP_PATH}/img/sports/${sportId}.png`}
                    alt={title}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = APP_PATH + '/img/bet25sport_icon.svg';
                    }}
                />
                <AndetToolbarTitle>{title}</AndetToolbarTitle>
                <ToggleIcon>
                    <i className="fa fa-angle-right" aria-hidden="true" />
                </ToggleIcon>
            </ToolbarContent>
        </AndetToolbarWrapper>
    );
};

export default ViewAnderSportToolbar;
